import React, { useEffect, useState } from 'react';
import './Login.scss';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginEmployee } from '../../services/userServices';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../redux/slice/userSlice';
import { Button } from 'react-bootstrap';
import { toAuthState } from '../../dto/auth.dto';

const Login = () => {
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [userCode, setUserCode] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isValidUserCode, setIsValidUserCode] = useState(true);
    const [isValidPassword, setIsValidPassword] = useState(true);
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        if (e) e.preventDefault();
        setIsValidUserCode(true);
        setIsValidPassword(true);

        if (!userCode || !password) {
            toast.error('Vui lòng điền đầy đủ thông tin đăng nhập');
            if (!userCode) setIsValidUserCode(false);
            if (!password) setIsValidPassword(false);
            return;
        }

        setLoading(true);
        try {
            let response = await loginEmployee(userCode, password, 'Employee');

            const authState = toAuthState(response);
            if (authState) {
                toast.success(response.message || 'Đăng nhập thành công');
                dispatch(login(authState));
                navigate("/");
            } else {
                toast.error(response?.error?.message || response?.message || 'Đăng nhập thất bại. Vui lòng kiểm tra lại tài khoản.');
            }
        } catch (err) {
            toast.error('Có lỗi xảy ra trong quá trình đăng nhập.');
        } finally {
            setLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    useEffect(() => {
        if (user.isAuthenticated) {
            navigate("/");
        }
    }, [user, navigate]);

    return (
        <div className="login-page-container">
            <div className="login-card shadow-lg">
                <div className="text-center mb-4">
                    <div className="login-icon-badge mb-3">
                        <i className="bi bi-shield-lock-fill text-primary fs-1"></i>
                    </div>
                    <h3 className="fw-extrabold text-dark mb-1">ĐĂNG NHẬP HỆ THỐNG</h3>
                    <div className="station-tag mt-2">
                        <i className="bi bi-laptop me-1"></i>
                        <span>Máy Trạm 01 - Mã M001</span>
                    </div>
                </div>

                <form onSubmit={handleLogin}>
                    <div className="form-group mb-3">
                        <label className="form-label text-secondary fw-semibold small">Mã nhân viên:</label>
                        <div className="input-group-custom">
                            <i className="bi bi-person input-icon"></i>
                            <input
                                type="text"
                                placeholder="Nhập mã nhân viên..."
                                value={userCode}
                                onChange={(e) => setUserCode(e.target.value)}
                                className={`form-control ${isValidUserCode ? '' : 'is-invalid'}`}
                            />
                        </div>
                        {!isValidUserCode && (
                            <span className="error-text">Vui lòng nhập mã nhân viên</span>
                        )}
                    </div>

                    <div className="form-group mb-4">
                        <label className="form-label text-secondary fw-semibold small">Mật khẩu:</label>
                        <div className="input-group-custom">
                            <i className="bi bi-lock input-icon"></i>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                className={`form-control ${isValidPassword ? '' : 'is-invalid'}`}
                                placeholder="Nhập mật khẩu..."
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <button
                                type="button"
                                className="password-toggle-btn"
                                onClick={togglePasswordVisibility}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>
                        {!isValidPassword && (
                            <span className="error-text">Vui lòng nhập mật khẩu</span>
                        )}
                    </div>

                    <Button
                        type="submit"
                        disabled={loading}
                        className="btn-login-submit w-100 py-3 rounded-3 fw-bold"
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Đang xử lý...
                            </>
                        ) : (
                            <>
                                <i className="bi bi-box-arrow-in-right me-2 fs-5"></i>
                                ĐĂNG NHẬP HỆ THỐNG
                            </>
                        )}
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default Login;
